import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { auditTrailService } from '../../../lib/auditTrailService';

const FailedPaymentsPanel = ({ onRefresh }) => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFailedPayments();
  }, []);

  const loadFailedPayments = async () => {
    setLoading(true);
    try {
      const { data } = await auditTrailService?.getFailedPayments({ limit: 50 });
      setPayments(data || []);
    } catch (error) {
      console.error('Error loading failed payments:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-heading font-semibold text-foreground">Failed Payments</h3>
        <span className="text-sm text-muted-foreground">{payments?.length || 0} failures</span>
      </div>
      <div className="space-y-3">
        {loading ? (
          <div className="text-center py-12">
            <Icon name="Loader" size={32} className="animate-spin text-primary mx-auto" />
          </div>
        ) : payments?.length === 0 ? (
          <div className="text-center py-12">
            <Icon name="CheckCircle" size={48} className="mx-auto mb-4 text-success" />
            <p className="text-muted-foreground">No failed payments</p>
          </div>
        ) : (
          payments?.map((payment) => (
            <div key={payment?.id} className="p-4 border border-error/20 bg-error/5 rounded-lg">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-error/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="CreditCard" size={20} className="text-error" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <h4 className="text-sm font-medium text-foreground">Payment Failed</h4>
                    <span className="px-2 py-0.5 rounded text-xs font-medium bg-error/15 text-error">
                      {payment?.severity}
                    </span>
                  </div>
                  <p className="text-sm text-muted-foreground mb-2">{payment?.event_description}</p>
                  <div className="flex items-center gap-4 text-xs text-muted-foreground">
                    <span className="flex items-center gap-1">
                      <Icon name="User" size={12} />
                      {payment?.user?.full_name || 'Unknown'}
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name="Building2" size={12} />
                      {payment?.gym?.name || 'N/A'}
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name="Clock" size={12} />
                      {new Date(payment?.created_at)?.toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default FailedPaymentsPanel;